<div class="toast" role="alert">
  <button type="button" class="toast-main" (click)="open()">
    <span class="toast-icon">
      <mat-icon aria-hidden="true">{{ alert.icon }}</mat-icon>
    </span>

    <span class="toast-text">
      <span class="toast-title">{{ alert.title }}</span>
      <span class="toast-message">{{ alert.message }}</span>
    </span>
  </button>

  <button type="button" class="toast-close" (click)="dismiss()" aria-label="Dismiss">
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>
</div>
